export class FindAllDashboardsError {
  public static readonly type =
    '[Project/Dashboard/List] FindAllDashboardsError';
  constructor(public readonly error: Error) {}
}
